import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import BasicButton from "components/button/BasicButton";
import { sendGet, sendPost } from "api/restUtil";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { getCommaNumber, getDateStr, getNowTimeHmsS, getTimeHms, getTodayStr, isEmpty, isValidDate, isValidHm } from "js/common";
import BasicInput from "components/input/BasicInput";
import DatePickerInput from "components/input/DatePickerInput";
import TimeInput from "components/input/TimeInput";
import CommonCodeSelect from "components/input/CommonCodeSelect";
import { checkAndRemoveInvalid, checkRequiredAndInvalid, makeRequireColumns, setInvalid } from "js/requireCheck";
import { getResultMsg } from "js/order";

/**
 * 배송완료(구매확정) 팝업
 */
function SendCompleteModal (props) {

	const { isOpen, modalId, onClose, data, initData } = props;
	const completeData = useRef(null);
	const [completeReason, setCompleteReason] = useState("");
	
	useEffect(() => {
		if(!isOpen) setCompleteReason("");
	}, [isOpen]);

	// 배송 완료 처리 (구매확정 처리)
	const productOrderSendComplete = async (productOrderId) => {
		
		if(isEmpty(completeReason)) {
			alert("사유를 입력해 주세요.");
			return;
		}
		let productOrderIds = null;
		if(productOrderId) {
			productOrderIds = data
				.filter(d => d.productOrder_productOrderId === productOrderId)
				.filter(d => d.productOrder_productOrderStatus === "DELIVERING")
				.map(d => d.productOrder_productOrderId);
		} else {
			// 결제 완료 상태인 상품 주문 번호
			productOrderIds = data
				.filter(d => d.productOrder_productOrderStatus === "DELIVERING")
				.map(d => d.productOrder_productOrderId);
		}
		if(productOrderIds == null || productOrderIds.length === 0) {
			alert("발주 가능한 상품주문이 없습니다.");
			return;
		}

		const deliveryCompleteYmdt = getTodayStr() + "T" + getNowTimeHmsS() + "+09:00";
		const reason = completeReason;
		
		if(!window.confirm("구매확정 처리 하시겠습니까?")) return;
		
		const result = await sendPost("/api/order/sendComplete", {productOrderIds: productOrderIds, deliveryCompleteYmdt: deliveryCompleteYmdt, deliveryCompleteInnerTreatmentReason: reason});
		if(result.respCode === "SUCCESS") {
			if(productOrderIds.length === result.data.data.successProductOrderIds.length) {
				alert("배송완료(구매확정) 처리 되었습니다.");
			} else {
				const msg = getResultMsg(result.data.data);
				alert(msg);
			}
			onClose(result.data.data.successProductOrderIds.length, result.data.data.failProductOrderInfos.length);
		}
	}




	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={"구매확정 팝업"}
			id={modalId}
		>

			<div className="me-modal">
				<div className="me-modal-container" style={{width: "500px", height: "150px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">구매확정 처리</h4>
						</div>
						<div className="me-modal-body" style={{overflowY: "auto", overflowX: "hidden"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="grid-table" style={{gridTemplateColumns: "1fr 5fr"}}>
								{/* <div className="th">상품주문번호</div>
								<div className="td">{completeData.current.productOrder_productOrderId}</div>
								<div className="th">상품명</div>
								<div className="td">{completeData.current.productOrder_productName}</div>
								<div className="th">수량</div>
								<div className="td">{completeData.current.productOrder_quantity}</div> */}
								<div className="th required">사유</div>
								<div className="td">
									<BasicInput item={{}} value={completeReason} onChange={(e) => setCompleteReason(e.target.value)} width="" textAlign="left" />
								</div>
							</div>
						</div>
						<div className="me-modal-footer mg-b-20" style={{marginTop: "auto"}}>
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="취소" className="btn-cancel" onClick={() => onClose(null)} style={{width: "100%"}} />
								<BasicButton label="확인" className="btn-save" onClick={() => productOrderSendComplete(initData.current.productOrder_productOrderId)} style={{width: "100%"}} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</ReactModal>
	);
}

export default SendCompleteModal;
